export const FeatureFlags = {
  NEW_DASHBOARD: 'feature.dashboard.new-layout',
  RECIPES_V2_EDITOR: 'feature.recipes.v2-editor',
  ONBOARDING_TOUR: 'feature.onboarding.tour',
  MAINTENANCE_MODE: 'ops.maintenance-mode',
} as const;

export type FeatureFlagKey = (typeof FeatureFlags)[keyof typeof FeatureFlags];

export interface FlagValueMap {
  [FeatureFlags.NEW_DASHBOARD]: boolean;
  [FeatureFlags.RECIPES_V2_EDITOR]: boolean;
  [FeatureFlags.ONBOARDING_TOUR]: boolean;
  [FeatureFlags.MAINTENANCE_MODE]: boolean;
}

export const FLAG_DEFAULTS: FlagValueMap = {
  [FeatureFlags.NEW_DASHBOARD]: false,
  [FeatureFlags.RECIPES_V2_EDITOR]: false,
  [FeatureFlags.ONBOARDING_TOUR]: false,
  [FeatureFlags.MAINTENANCE_MODE]: false,
};
